import { render, staticRenderFns } from "./MessagePushDetail.vue?vue&type=template&id=4584989a&"
import script from "./MessagePushDetail.vue?vue&type=script&lang=js&"
export * from "./MessagePushDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports